import { Core } from '../Core/Core';
import {
  DASHBOARD_EVENT_HEATMAP,
  DASHBOARD_KPI_SUMMARY,
  DASHBOARD_LOAD_PULLING_OVERVIEW,
  DASHBOARD_LOAD_PULLING_SUMMARY,
  DASHBOARD_MAINTENANCE,
  DASHBOARD_STOCK_BY_COMPOUND,
  DASHBOARD_STOCK_BY_MODEL,
  DASHBOARD_STOCK_BY_STATUS,
  DASHBOARD_THROUGHPUT_TREND,
} from '../Core/endpoints';
import {
  CategoryCount,
  CompoundStock,
  KpiSummary,
  LoadPullingOverview,
  LoadPullingSummary,
  MaintenanceSeries,
  TrendPoint,
} from './types';

class OperationsDashboardApi extends Core {
  getKpiSummary = async (params?: { from?: string; to?: string }) =>
    this.get<KpiSummary>(DASHBOARD_KPI_SUMMARY(), params);

  getThroughputTrend = async (params?: { endDate?: string; weeks?: number }) =>
    this.get<TrendPoint[]>(DASHBOARD_THROUGHPUT_TREND(), params);

  getStockByCompound = async () =>
    this.get<CompoundStock[]>(DASHBOARD_STOCK_BY_COMPOUND());

  getStockByModel = async (params?: { top?: number }) =>
    this.get<CategoryCount[]>(DASHBOARD_STOCK_BY_MODEL(), params);

  getStockByStatus = async () =>
    this.get<CategoryCount[]>(DASHBOARD_STOCK_BY_STATUS());

  getEventHeatmap = async () =>
    this.get<CategoryCount[]>(DASHBOARD_EVENT_HEATMAP());

  getLoadPullingOverview = async () =>
    this.get<LoadPullingOverview>(DASHBOARD_LOAD_PULLING_OVERVIEW());

  getLoadPullingSummary = async (siteId: number, customerId?: number) =>
    this.get<LoadPullingSummary>(
      DASHBOARD_LOAD_PULLING_SUMMARY(siteId, customerId),
    );

  getMaintenance = async (params?: { weeks?: number }) =>
    this.get<MaintenanceSeries[]>(DASHBOARD_MAINTENANCE(), params);
}

export const operationsDashboard = new OperationsDashboardApi();
